export enum MediaType {
  CARD = 'card',
  FILE = 'file'
}
